import { useClickAway } from 'ahooks';
import get from 'lodash/get';
import { useRef } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import type { HierarchyMenuItem } from '../../types';
import './style.less';

type Props = {
    menus: HierarchyMenuItem[];
    onOperate: (item: HierarchyMenuItem) => void;
    onClickAway?: () => void;
};

export const Menu = ({ menus, onOperate, onClickAway }: Props) => {
    const { $t } = useLocaleStore();
    const containerRef = useRef<HTMLDivElement>(null);

    useClickAway(() => onClickAway?.(), containerRef);

    return (
        <div className="hierarchy-menu" ref={containerRef}>
            {menus.map((item) => (
                <div
                    key={item.operation}
                    className="hierarchy-menu__item"
                    onClick={(event) => {
                        event.stopPropagation();
                        onOperate(item);
                    }}
                >
                    <IconFont name={item.icon} fontSize={16} />
                    <span className="hierarchy-menu__text">{$t((value) => get(value, item.labelKeyPath))}</span>
                </div>
            ))}
        </div>
    );
};
